module.exports = __webpack_public_path__ + "static/media/ana_margarida_baptista.4b91b725.jpg";